/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/AddAction"
  
}) {
let referralsValueData = fromData.useDataFormat({ viewPath,
context: 'referrals',
format: fromFormat.isNotEmptyList,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let referralsValueData1 = fromData.useDataFormat({ viewPath,
context: 'referrals',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 marginTop={referralsValueData ? dtSpaceS : "0px"}
 data="referrals"
 format="/Data/format.js isNotEmptyList"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={referralsValueData1 ? "Add another referral" : "Add referral"}
 data="referrals"
 format="/Data/format.js isNotEmptyList"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}